import { createStore } from 'vuex'

export default createStore({
  state: {
    commonParams: {
      token: "",
      unitId: "",
      userId: "",
      appTag: "appTag"
    } as any
  },
  mutations: {
    get_common_params(state,obj){
      state.commonParams=obj
    }
  },
  actions: {
  },
  modules: {
  }
})
